import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import classnames from 'classnames';
import { Theme } from '@app/theme';
import { Trans } from 'react-i18next';
import { Colors } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  titleLine: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.marginBase * 2,
  },
  titleWithBorder: {
    borderBottom: {
      width: 1,
      color: theme.colors.grayBorder,
      style: 'solid',
    },
    paddingBottom: theme.marginBase * 2,
    marginBottom: theme.marginBase * 3,
  },
  title: {
    ...theme.fonts.label,
    textTransform: 'uppercase',
  },
  iconContainer: {
    fontSize: theme.iconSize.small,

    width: theme.height.chips,
    height: theme.height.chips,
    borderRadius: theme.height.chips / 2,

    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',

    marginRight: theme.marginBase,
  },
  ...theme.mutedColorCombinations,
}));

interface Props {
  icon: string;
  title: string;
  iconColor?: Colors;
  noBorder?: boolean;
  className?: string;
}

export const TitleWithIcon = ({
  icon,
  title,
  iconColor = 'blue',
  noBorder,
  className,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classnames(
        classes.titleLine,
        {
          [classes.titleWithBorder]: !noBorder,
        },
        className,
      )}
    >
      <div className={classnames(classes.iconContainer, classes[iconColor])}>
        <i className={icon} />
      </div>
      <h3 className={classes.title}>{title}</h3>
    </div>
  );
};
